import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { FirebaseApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { FIREBASE_APP } from './firebase-app.token';
import { FIREBASE_AUTH, GOOGLE_AUTH_PROVIDER } from './firebase-auth.token';
import { googleAuthProviderFactory } from './google-auth-provider.factory';

export const provideFirebaseAuth = (): EnvironmentProviders =>
  makeEnvironmentProviders([
    {
      provide: FIREBASE_AUTH,
      deps: [FIREBASE_APP],
      useFactory: (app: FirebaseApp) => getAuth(app),
    },
    {
      provide: GOOGLE_AUTH_PROVIDER,
      useFactory: googleAuthProviderFactory,
    },
  ]);
